import gql from 'graphql-tag';

export const notificationFragment = gql`
  fragment Notification on Notification {
    id
    type
    user_id
    activity_id
    activity {
      id
      type
      subtype
      subaction
      objectable_id
      objectable_type
      created_at
      project_id
      project {
        id
        name
      }
      data
      user {
        id
        username
        first_name
        last_name
        avatar {
          id
          path
        }
      }
    }
    data
    status
    created_at
  }
`;



// WEBPACK FOOTER //
// ./src/components/buttons/NotificationsButton/fragments/notificationFragment.js